// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartConfigurationRegistration.jsx"
// company="Izenda">  Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import './FieldContainers/Izenda.FieldContainerRegistration';

// Register chart configuration
import './ReportPartChart/Izenda.DefaultChartConfiguration';
import './ReportPartChart/Izenda.LineChartConfiguration';
import './ReportPartChart/Izenda.ColumnChartConfiguration';
import './ReportPartChart/Izenda.BarChartConfiguration';
import './ReportPartChart/Izenda.AreaChartConfiguration';
import './ReportPartChart/Izenda.PieChartConfiguration';
import './ReportPartChart/Izenda.FunnelChartConfiguration';
import './ReportPartChart/Izenda.DonutChartConfiguration';
import './ReportPartChart/Izenda.CombinationChartConfiguration';
import './ReportPartChart/Izenda.TreemapChartConfiguration';
import './ReportPartChart/Izenda.HeatmapChartConfiguration';
import './ReportPartChart/Izenda.BubbleChartConfiguration';
import './ReportPartChart/Izenda.ScatterChartConfiguration';
import './ReportPartChart/Izenda.WaterfallChartConfiguration';
import './ReportPartChart/Izenda.SparklineChartConfiguration';

// Register form configuration
import './ReportPartForm/Izenda.DefaultFormConfiguration';

// Register grid configuration
import './ReportPartGrid/Izenda.DefaultGridConfiguration';

// Register gauge configuration
import './ReportPartGauge/Izenda.DefaultGaugeConfiguration';
import './ReportPartGauge/Izenda.LinearGaugeConfiguration';
import './ReportPartGauge/Izenda.SimpleGaugeConfiguration';
import './ReportPartGauge/Izenda.SolidGaugeConfiguration';

// Register map configuration
import './ReportPartMap/Izenda.DefaultMapConfiguration';
import './ReportPartMap/Izenda.GoogleMapsConfiguration';
import './ReportPartMap/Izenda.WorldMapConfiguration';
import './ReportPartMap/Izenda.ContinentMapConfiguration';
import './ReportPartMap/Izenda.CountryMapConfiguration';

// D3
import 'share/components/charting/d3/Izenda.D3ChartConfigurations';


// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.ReportPartConfigurationRegistration.js